import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RootLayout } from '../root/root.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'simplywhite-layout',
  templateUrl: './simplywhite.component.html',
  styleUrls: ['./simplywhite.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SimplyWhiteLayout extends RootLayout implements OnInit {

  menuLinks = [
    {
      label: 'All Deals',
      // details: '12 New Updates',
      routerLink: '/',
      // iconType: 'fi',
      // iconName: 'home',
      roles: ['admin', 'corporate', 'office_manager'],
    },
    {
      label: 'View Deal',
      // details: '12 New Updates',
      routerLink: '/deals/open',
      // iconType: 'fi',
      // iconName: 'home',
      roles: ['installer'],
    },
    {
      label: 'Calendar',
      // details: '12 New Updates',
      routerLink: '/calendar',
      // iconType: 'fi',
      // iconName: 'calendar'
    },
    {
      label: 'Deals',
      // iconType: 'fi',
      // iconName: 'clipboard',
      toggle: 'close',
      roles: ['admin', 'estimator', 'corporate', 'office_manager'],
      submenu: [
        {
          label: 'All Deals',
          routerLink: '/deals/list',
          // iconType: 'letter',
          // iconName: 'l',
        },
        {
          label: 'Create Deal',
          routerLink: '/deals/create',
          // iconType: 'letter',
          // iconName: 'dl',
          roles: ['admin', 'estimator', 'corporate', 'office_manager'],
        },
        {
          label: 'Schedule',
          routerLink: '/deals/installation-scheduling',
          // iconType: 'letter',
          // iconName: 'is',
          roles: ['admin', 'corporate', 'office_manager'],
        },
        {
          label: 'Commissions',
          routerLink: '/deals/commissions',
          // iconType: 'letter',
          // iconName: 'ir',
          roles: ['admin', 'accounting', 'corporate', 'office_manager'],
        },
      ]
    },
    {
      label: 'Inventory',
      // iconType: 'fi',
      // iconName: 'shapes',
      toggle: 'close',
      roles: ['admin', 'accounting', 'corporate', 'office_manager'],
      submenu: [
        {
          label: 'Film Rolls',
          routerLink: '/inventory/film-rolls',
          // iconType: 'letter',
          // iconName: 'dl'
        },
      ]
    },
    {
      label: 'Contacts',
      // iconType: 'fi',
      // iconName: 'users',
      toggle: 'close',
      roles: ['admin', 'accounting', 'corporate', 'office_manager', 'estimator'],
      submenu: [
        {
          label: 'Contacts',
          routerLink: '/contacts',
          // iconType: 'letter',
          // iconName: 'dl'
        },
        {
          label: 'Companies',
          routerLink: '/contacts/companies',
          // iconType: 'letter',
          // iconName: 'sl'
        },
      ]
    },
    {
      label: 'Reports',
      toggle: 'close',
      roles: ['admin', 'accounting', 'office_manager', 'installer'],
      submenu: [
        {
          label: 'Commission Report',
          routerLink: '/reports/commission',
          roles: ['admin', 'accounting', 'office_manager', 'installer'],
        },
        {
          label: 'Hours Report',
          routerLink: '/reports/hours-report',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Materials Used',
          routerLink: '/reports/materials-used',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Discounts Report',
          routerLink: '/reports/discounts-report',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Film Transfers',
          routerLink: '/reports/transfers',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Film Exceptions',
          routerLink: '/reports/exceptions-inventory-report',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Goback Report',
          routerLink: '/reports/goback',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Event Report',
          routerLink: '/reports/event',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Payroll Exceptions',
          routerLink: '/reports/exceptions-payroll-report',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Billing Exceptions',
          routerLink: '/reports/exceptions-billing-report',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Accounting Report',
          routerLink: '/reports/accounting-report',
          roles: ['admin', 'accounting', 'office_manager'],
        },
        {
          label: 'Progress Report',
          routerLink: '/reports/progress-report',
          roles: ['admin', 'accounting', 'office_manager'],
        },
      ]
    },

    // {
    //   label: 'Pipeline',
    //   // details: '12 New Updates',
    //   routerLink: '/pipeline/sales',
    //   iconType: 'fi',
    //   roles: ['admin'],
    //   iconName: 'layout'
    // },

    {
      label: 'Admin',
      // iconType: 'fi',
      // iconName: 'shield',
      toggle: 'close',
      roles: ['admin'],
      submenu: [
        {
          label: 'Users',
          routerLink: '/admin/users',
          // iconType: 'letter',
          // iconName: 'us'
        },
        {
          label: 'Core Weight',
          routerLink: '/admin/core-weight',
          // iconType: 'letter',
          // iconName: 'cw'
        },
        {
          label: 'Window Service',
          routerLink: '/admin/window-services',
          // iconType: 'letter',
          // iconName: 'ws'
        },
        // {
        //   label: 'Installer Rates',
        //   routerLink: '/admin/installer-rates',
        //   // iconType: 'letter',
        //   // iconName: 'ir'
        // },
        {
          label: 'Silicone Types',
          routerLink: '/admin/silicone-types',
          // iconType: 'letter',
          // iconName: 'ws'
        },
        {
          label: 'Films',
          routerLink: '/admin/films',
          // iconType: 'letter',
          // iconName: 'f'
        },
        // {
        //   label: 'Film Type',
        //   routerLink: '/admin/film-types',
        //   // iconType: 'letter',
        //   // iconName: 'ft'
        // },
        {
          label: 'Film Category',
          routerLink: '/admin/film-category',
          // iconType: 'letter',
          // iconName: 'fc'
        },
        {
          label: 'Manufacturer',
          routerLink: '/admin/manufacturers',
          // iconType: 'letter',
          // iconName: 'm'
        },
        {
          label: 'Roll Widths',
          routerLink: '/admin/roll-widths',
          // iconType: 'letter',
          // iconName: 'rw'
        },
        {
          label: 'Offices',
          routerLink: '/admin/offices',
          // iconType: 'letter',
          // iconName: 'o'
        },
        {
          label: 'Goback Reasons',
          routerLink: '/admin/goback',
        },
        // {
        //   label: 'Contact Types',
        //   routerLink: '/admin/contact-types',
        //   // iconType: 'letter',
        //   // iconName: 'ct'
        // },
        // {
        //   label: 'Lead Sources',
        //   routerLink: '/admin/lead-sources',
        //   // iconType: 'letter',
        //   // iconName: 'ls'
        // },
        {
          label: 'Config',
          routerLink: '/admin/quickbooks',
          // iconType: 'letter',
          // iconName: 'qb'
        },
        {
          label: 'Deal Thumbnails',
          routerLink: '/admin/deal-thumbnails',
        },
        {
          label: 'Bulk Edit',
          routerLink: '/admin/bulk-edit',
        },
      ]
    },
    
    {
      label: 'Demo',
      roles: ['demo'],
      toggle: 'close',
      routerLink: '/simplywhite',
      submenu: [
        {
          label: 'Email',
          details: '234 New Emails',
          routerLink: '/simplywhite/email/light/list',
          iconType: 'fi',
          iconName: 'mail'
        },
        // {
        //   label: 'Social',
        //   routerLink: '/simplywhite/social',
        //   iconType: 'fi',
        //   iconName: 'users'
        // },
        {
          label: 'Builder',
          routerLink: '/simplywhite/builder/simplywhite-builder',
          iconType: 'fi',
          iconName: 'cpu'
        },
        {
          label: 'Layouts',
          iconType: 'fi',
          iconName: 'layout',
          // toggle: 'close',
          submenu: [
            {
              label: 'Default',
              routerLink: '/simplywhite/layouts/default',
              iconType: 'letter',
              iconName: 'dl'
            },
            {
              label: 'Secondary',
              routerLink: '/simplywhite/layouts/secondary-light',
              iconType: 'letter',
              iconName: 'sl'
            },
            {
              label: 'Boxed',
              routerLink: '/simplywhite/layouts/boxed-alt',
              iconType: 'letter',
              iconName: 'bl'
            }
          ]
        },
        {
          label: 'UI Elements',
          iconType: 'fi',
          iconName: 'triangle',
          // toggle: 'close',
          submenu: [
            {
              label: 'Color',
              routerLink: '/simplywhite/ui/color',
              iconType: 'letter',
              iconName: 'c'
            },
            {
              label: 'Typography',
              routerLink: '/simplywhite/ui/typography',
              iconType: 'letter',
              iconName: 't'
            },
            {
              label: 'Icons',
              routerLink: '/simplywhite/ui/icons',
              iconType: 'letter',
              iconName: 'i'
            },
            {
              label: 'Buttons',
              routerLink: '/simplywhite/ui/buttons',
              iconType: 'letter',
              iconName: 'b'
            },
            {
              label: 'Notifications',
              routerLink: '/simplywhite/ui/notifications',
              iconType: 'letter',
              iconName: 'n'
            },
            {
              label: 'Modals',
              routerLink: '/simplywhite/ui/modal',
              iconType: 'letter',
              iconName: 'm'
            },
            {
              label: 'Progress & Activity',
              routerLink: '/simplywhite/ui/progress',
              iconType: 'letter',
              iconName: 'pa'
            },
            {
              label: 'Tabs & Accordians',
              routerLink: '/simplywhite/ui/tabs',
              iconType: 'letter',
              iconName: 'a'
            },
            {
              label: 'Sliders',
              routerLink: '/simplywhite/ui/sliders',
              iconType: 'letter',
              iconName: 's'
            },
            {
              label: 'Treeview',
              routerLink: '/simplywhite/ui/tree',
              iconType: 'letter',
              iconName: 'tv'
            }
          ]
        },
        {
          label: 'Forms',
          iconType: 'fi',
          iconName: 'list',
          // toggle: 'close',
          submenu: [
            {
              label: 'Form Elements',
              routerLink: '/simplywhite/forms/elements',
              iconType: 'letter',
              iconName: 'fe'
            },
            {
              label: 'Form Layouts',
              routerLink: '/simplywhite/forms/layouts',
              iconType: 'letter',
              iconName: 'fl'
            },
            {
              label: 'Form Wizard',
              routerLink: '/simplywhite/forms/wizard',
              iconType: 'letter',
              iconName: 'fq'
            }
          ]
        },
        {
          label: 'Cards',
          routerLink: '/simplywhite/cards',
          iconType: 'fi',
          iconName: 'grid'
        },
        {
          label: 'Views',
          routerLink: '/simplywhite/views',
          iconType: 'fi',
          iconName: 'airplay'
        },
        {
          label: 'Tables',
          iconType: 'fi',
          iconName: 'square',
          // toggle: 'close',
          submenu: [
            {
              label: 'Basic Tables',
              routerLink: '/simplywhite/tables/basic',
              iconType: 'letter',
              iconName: 'bt'
            },
            {
              label: 'Advance Tables',
              routerLink: '/simplywhite/tables/advance',
              iconType: 'letter',
              iconName: 'dt'
            }
          ]
        },
        {
          label: 'Maps',
          iconType: 'fi',
          iconName: 'map-pin',
          // toggle: 'close',
          submenu: [
            {
              label: 'Google Maps',
              routerLink: '/simplywhite/maps/google',
              iconType: 'letter',
              iconName: 'gm'
            }
          ]
        },
        {
          label: 'Charts',
          routerLink: '/simplywhite/charts',
          iconType: 'fi',
          iconName: 'bar-chart'
        },
        {
          label: 'Extra',
          iconType: 'fi',
          iconName: 'box',
          // toggle: 'close',
          submenu: [
            {
              label: 'Invoice',
              routerLink: '/simplywhite/extra/invoice',
              iconType: 'letter',
              iconName: 'in'
            },
            {
              label: '404 Page',
              routerLink: '/simplywhite/session/error/404',
              iconType: 'letter',
              iconName: 'pg'
            },
            {
              label: '500 Page',
              routerLink: '/simplywhite/session/error/500',
              iconType: 'letter',
              iconName: 'pg'
            },
            {
              label: 'Login',
              routerLink: '/simplywhite/session/login',
              iconType: 'letter',
              iconName: 'l'
            },
            {
              label: 'Register',
              routerLink: '/simplywhite/session/register',
              iconType: 'letter',
              iconName: 're'
            },
            {
              label: 'Lockscreen',
              routerLink: '/simplywhite/session/lock',
              iconType: 'letter',
              iconName: 'ls'
            },
            {
              label: 'Gallery',
              routerLink: '/simplywhite/extra/gallery',
              iconType: 'letter',
              iconName: 'gl'
            },
            {
              label: 'Timeline',
              routerLink: '/simplywhite/extra/timeline',
              iconType: 'letter',
              iconName: 't'
            }
          ]
        },
        {
          label: 'Docs',
          externalLink: 'https://docs.pages.revox.io/v/angular/',
          target: '_blank',
          iconType: 'fi',
          iconName: 'life-buoy'
        },
        {
          label: 'Changelog',
          externalLink: 'http://changelog.pages.revox.io/',
          target: '_blank',
          iconType: 'letter',
          iconName: 'CG'
        }
      ]
    },
  ];

  environment = environment;
  ngOnInit() {
    this.changeLayout('menu-pin');
    //Will sidebar close on screens below 1024
    this.autoHideMenuPin();
  }
}
